import React from 'react'
import { trans } from '../../../../_providers/Translation'
import DateRange from '@/components/partials/DateRange'

function Filter(props) {

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleSelectMobileFilter = e => {
        let selectedValue = e.target.value
        let fields = [...document.querySelectorAll('.filter-standard .col')]
        fields.map(field => {
            if (field.getAttribute('data-id') == selectedValue) field.style.display = 'flex'
            else if (field.getAttribute('data-id')) field.style.display = 'none'
        })
    }

    const handleClearFilters = () => {
        props.handleSearch('start_date', '')
        props.handleSearch('end_date', '')
        props.handleSearch('search', '')
        props.handleSearch('type_id', '')
    }

    return (
        <form className="filter-standard">
            <div className="col select-filter-col">
                <label>
                    {trans('filters.filterBy')}
                </label>
                <select onChange={handleSelectMobileFilter}>
                    <option value="1">
                        {trans('filters.startDate')}
                    </option>
                    <option value="2">
                        {trans('filters.endDate')}
                    </option>
                    <option value="3">
                        {trans('filters.search')}
                    </option>
                </select>
            </div>

            <div className="col" data-id="1">
                <select
                    name="type_id"
                    value={props.filter.type_id || ''}
                    onChange={handleSearch}
                >
                    <option value="">{trans('invoice.type')}</option>
                    <option value={1}>
                        {trans('invoice.proforma')}
                    </option>
                    <option value={2}>
                        {trans('invoice.invoice')}
                    </option>
                </select>
            </div>

            <div className="col" data-id="1">
                <DateRange
                    startDate={props.filter.start_date}
                    endDate={props.filter.end_date}
                    onStartDateChange={(date) => {
                        props.handleSearch('start_date', date)
                    }} onEndDateChange={(date) => {
                        props.handleSearch('end_date', date)
                    }}
                />
            </div>

            <div className="col" data-id="3">
                <input
                    type="search"
                    name="search"
                    placeholder={trans('random.clientDocNo')}
                    className="field-big"
                    value={props.filter.search}
                    onChange={handleSearch}
                />
            </div>
            <div className='col'>
                <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                    {trans('buttons.clearFilter')}
                </button>
            </div>
        </form>
    )
}

export default React.memo(Filter, (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next)
})